import { Col, Hr } from "@amzn/stencil-react-components/layout";

import { MoreHelp } from "@/components/GetSupport/SelfHelpFAQ/FAQ/Footer/MoreHelp";

/**
 * Interface for FAQ Footer props
 * @interface FAQFooterProps
 * @property {Function} onChatClick - Optional callback function when chat is clicked
 */
interface FAQFooterProps {
  onChatClick?: () => void;
}

/**
 * A footer component for FAQ sections that displays a horizontal line
 * and a "More Help" section with optional chat functionality.
 *
 * @param {Function} onChatClick - Optional callback when chat is clicked
 */

export const FAQFooter = ({ onChatClick }: FAQFooterProps) => (
  <Col gridGap="S300" className={"faq-footer"}>
    <Hr color="neutral20" size="narrow" />
    <MoreHelp onChatClick={onChatClick} />
  </Col>
);
